import React, { useLayoutEffect, useRef, useState } from "react";

export default function ReferenceImageViewer({ src, title, alt, onClose }) {
  const dialogRef = useRef(null);
  const closeRef = useRef(null);
  const [zoom, setZoom] = useState("actual");

  useLayoutEffect(() => {
    const previous = document.activeElement;
    const keepFocus = (event) => {
      if (!dialogRef.current?.contains(event.target)) closeRef.current?.focus();
    };
    closeRef.current?.focus();
    document.addEventListener("focusin", keepFocus);
    return () => {
      document.removeEventListener("focusin", keepFocus);
      if (previous?.isConnected) previous.focus?.();
    };
  }, []);

  const onKeyDown = (event) => {
    event.stopPropagation();
    if (event.key === "Escape") { event.preventDefault(); onClose(); }
    if (event.key === "Tab") {
      const items = [...dialogRef.current.querySelectorAll('button:not(:disabled),[tabindex="0"]')];
      const index = items.indexOf(document.activeElement);
      event.preventDefault();
      items[(index + (event.shiftKey ? -1 : 1) + items.length) % items.length]?.focus();
    }
  };

  return <div className="adminReferenceImageBackdrop" onKeyDown={onKeyDown}>
    <section ref={dialogRef} className="adminReferenceImageViewer" role="dialog" aria-modal="true" aria-label={title}>
      <header className="adminReferenceImageHeader">
        <h3>{title}</h3>
        <div className="adminReferenceImageActions">
          <button type="button" className="adminSecondaryButton" aria-pressed={zoom === "actual"}
            onClick={() => setZoom("actual")}>Actual size</button>
          {[100, 150, 200].map((value) => <button key={value} type="button" className="adminSecondaryButton"
            aria-pressed={zoom === value} onClick={() => setZoom(value)}>{value === 100 ? "Fit width" : `${value}%`}</button>)}
          <button ref={closeRef} type="button" className="adminSecondaryButton" onClick={onClose}>Close preview</button>
        </div>
      </header>
      <div className="adminReferenceImageViewport" tabIndex={0} role="region" aria-label="Chart image; scroll to inspect details">
        <img src={src} alt={alt} style={{ width: zoom === "actual" ? "auto" : `${zoom}%` }} />
      </div>
    </section>
  </div>;
}
